(() => {
  const all = (selector) => Array.from(document.querySelectorAll(`.zendure-kit-page ${selector}`));

  function updateProductVariant(select) {
    const option = select.selectedOptions[0];
    const card = select.closest('.product-card');
    if (!option || !card) return;
    const price = card.querySelector('.price');
    const comparePrice = card.querySelector('.compare-price');
    const image = card.querySelector('.product-image');
    const link = card.querySelector('.product-link');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (comparePrice) comparePrice.textContent = option.dataset.compare || '';
    if (image && option.dataset.image) image.src = option.dataset.image;
    if (link && option.dataset.url) link.href = option.dataset.url;
  }

  function positionFunctionPopover(button, popover) {
    if (!popover || window.getComputedStyle(popover).display === 'none') return;
    const stage = button.closest('.function-stage');
    if (!stage) return;
    const stageRect = stage.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();
    const gap = 14;
    const inset = 12;
    const buttonLeft = buttonRect.left - stageRect.left;
    const buttonTop = buttonRect.top - stageRect.top;
    let left = buttonLeft;
    let top = buttonTop;
    if (popover.dataset.placement === 'left') {
      left = buttonLeft - popoverRect.width - gap;
      top = buttonTop + (buttonRect.height - popoverRect.height) / 2;
    } else if (popover.dataset.placement === 'right') {
      left = buttonLeft + buttonRect.width + gap;
      top = buttonTop + (buttonRect.height - popoverRect.height) / 2;
    } else if (popover.dataset.placement === 'top') {
      left = buttonLeft + (buttonRect.width - popoverRect.width) / 2;
      top = buttonTop - popoverRect.height - gap;
    } else {
      left = buttonLeft + (buttonRect.width - popoverRect.width) / 2;
      top = buttonTop + buttonRect.height + gap;
    }
    popover.style.left = `${Math.max(inset, Math.min(left, stageRect.width - popoverRect.width - inset))}px`;
    popover.style.top = `${Math.max(inset, Math.min(top, stageRect.height - popoverRect.height - inset))}px`;
  }

  function showFunctionDetail(button) {
    const popover = document.getElementById(button.dataset.popover);
    positionFunctionPopover(button, popover);
    all('.function-hotspot').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-expanded', String(active));
    });
    all('.function-popover').forEach((item) => item.classList.toggle('is-active', item === popover));
    const detailTitle = document.getElementById('function-detail-title');
    const detailText = document.getElementById('function-detail-text');
    if (detailTitle) detailTitle.textContent = button.dataset.title || '';
    if (detailText) detailText.textContent = button.dataset.detail || '';
  }

  function activateComparisonTab(tab) {
    const tabs = all('.mobile-comparison-tab');
    tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
    all('.comparison-detail-row').forEach((row) => row.classList.toggle('is-active', row.id === tab.dataset.compareTarget));
    tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function initZendureKitPage() {
    all('.variant-select').forEach((select) => {
      if (!select.dataset.zdBound) {
        select.addEventListener('change', () => updateProductVariant(select));
        select.dataset.zdBound = 'true';
      }
      updateProductVariant(select);
    });

    all('.function-hotspot').forEach((button) => {
      if (button.dataset.zdBound) return;
      button.addEventListener('mouseenter', () => showFunctionDetail(button));
      button.addEventListener('focus', () => showFunctionDetail(button));
      button.addEventListener('click', () => showFunctionDetail(button));
      button.dataset.zdBound = 'true';
    });
    const initialFunctionButton = document.querySelector('.zendure-kit-page .function-hotspot.is-active');
    if (initialFunctionButton) showFunctionDetail(initialFunctionButton);

    all('.scene-tab').forEach((tab) => {
      if (tab.dataset.zdBound) return;
      tab.addEventListener('click', () => {
        all('.scene-tab').forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        const targetPanel = document.getElementById(`scene-${tab.dataset.scene}`);
        if (!targetPanel) return;
        all('.scene-panel').forEach((panel) => { panel.hidden = panel !== targetPanel; });
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          targetPanel.animate(
            [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 320, easing: 'cubic-bezier(.22, .8, .32, 1)' }
          );
        }
      });
      tab.dataset.zdBound = 'true';
    });

    const comparisonTabs = all('.mobile-comparison-tab');
    comparisonTabs.forEach((tab, index) => {
      if (tab.dataset.zdBound) return;
      tab.addEventListener('click', () => activateComparisonTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const next = comparisonTabs[(index + direction + comparisonTabs.length) % comparisonTabs.length];
        next.focus();
        activateComparisonTab(next);
      });
      tab.dataset.zdBound = 'true';
    });
  }

  if (!document.documentElement.dataset.zdKitResizeBound) {
    window.addEventListener('resize', () => {
      const activeButton = document.querySelector('.zendure-kit-page .function-hotspot.is-active');
      if (activeButton) positionFunctionPopover(activeButton, document.getElementById(activeButton.dataset.popover));
    });
    document.documentElement.dataset.zdKitResizeBound = 'true';
  }

  initZendureKitPage();
  document.addEventListener('shopify:section:load', initZendureKitPage);
})();
